<template>
  <b-sidebar
    id="add-new-role-sidebar"
    :visible="isAddNewRoleSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    width="35em"
    backdrop
    no-header
    right
    @hidden="resetRoleData"
    @change="(val) => $emit('update:is-add-new-role-sidebar-active', val)"
  >

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Create New Role')}}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>

      <!-- BODY -->
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="onSubmit">

          <b-row>
            <b-col cols="12">
              <!-- Name -->
              <b-form-group :label="$t('Name')" label-for="name">
                <b-form-input
                    id="name"
                    v-model="roleData.name"
                    autofocus
                    :state="(errors && ('name' in errors)) ? false : null"
                    trim
                    autocomplete="off"
                    placeholder=""
                />

                <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="(errors && ('name' in errors)) ? false : null">
                  {{  $t(errors.name[0])  }}
                </b-form-invalid-feedback>

              </b-form-group>
            </b-col>
          </b-row>

          <!-- Form Actions -->
          <div class="d-flex">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              type="submit"
            >
              {{ $t('Add')}}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="resetRoleData">
              {{ $t('Cancel')}}
            </b-button>
          </div>
        </b-form>

    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
    BRow,BCol
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,BRow,BCol,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    OrbitSpinner,

    flatPickr,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewRoleSidebarActive',
    event: 'update:is-add-new-role-sidebar-active',
  },
  props: {
    isAddNewRoleSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit, root }) {

    const blankRoleData = {
      name: '',
    }

    const errors = ref(null)

    const requestStatus = ref(false)

    const roleData = ref(JSON.parse(JSON.stringify(blankRoleData)))

    const resetRoleData = () => roleData.value = JSON.parse(JSON.stringify(blankRoleData))

    const onSubmit = () => {

      requestStatus.value = true
      store.dispatch('roles/addRole', roleData.value)
        .then(() => {
          requestStatus.value = false
          emit('refetch-data')
          emit('update:is-add-new-role-sidebar-active', false)

          root.$bvToast.toast(
              root.$i18n.t("Successfully Adding Role"), {
                title: `Success`,
                variant: 'success',
              })

        }).catch(res => {
          requestStatus.value = false
            if (res.response.status === 422) {
              errors.value = res.response.data.errors
            }
          }
      )
    }



    return {
      roleData,
      onSubmit,
      resetRoleData,
      requestStatus,
      errors
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
